import React from 'react';
import SidebarParametres from '../../../layout/SidebarParametres';
import { useOAD } from '../../../layout/OADLayout';
import { api } from '../../shared/api/api';
import { useApiData } from '../../shared/hooks/useFetch';
import LimiteErreur from '../../shared/components/LimiteErreur';
import { RCP_OPTIONS } from '../../shared/constants';
import { useHorizon } from '../../shared/hooks/useHorizon';
import { libelleHorizon } from '../../shared/utils/horizon';
import ClassementAdaptationsChart from '../../shared/charts/ClassementAdaptationsChart';

/** Adaptations / Classement des solutions (graphique en mock). */
export default function Classement() {
  const { idExploit } = useOAD();
  const [rcp, setRcp] = React.useState(RCP_OPTIONS[0].value);
  // En TRACC, l'année (2035/2050) n'a pas de sens : on bascule sur les
  // niveaux de réchauffement (+2°C / +2.7°C), cf. shared/utils/horizon.js.
  // (horizonsSelectionnables ne teste que scenario === 'tracc', et rcp vaut
  // déjà 'tracc' tel quel dans RCP_OPTIONS.)
  const [annee, setAnnee, anneesPossibles] = useHorizon(rcp, {
    // 2020 (ou la référence en TRACC) proposée en plus de 2035/2050 ; 2035 (ou
    // +2°C) reste coché à l'ouverture.
    avecReference: true,
    indexParDefaut: 1,
  });

  const parametres = React.useMemo(
    () => ({ idExploitation: idExploit, annee, rcp }),
    [idExploit, annee, rcp]
  );
  const { data, loading, error } = useApiData(api.getClassementSolutions, parametres);

  return (
    <div className="oad-contenu">
      <SidebarParametres
        niveau1="2035-2050"
        niveau2="adaptations"
        niveau3="classement"
        idExploit={idExploit}
      >
        <label className="sidebar-champ">
          <span className="sidebar-label">{rcp === 'tracc' ? 'Réchauffement' : 'Année'}</span>
          <select value={annee} onChange={(e) => setAnnee(e.target.value)}>
            {anneesPossibles.map((h) => (
              <option key={h} value={h}>{libelleHorizon(rcp, h)}</option>
            ))}
          </select>
        </label>

        <fieldset className="sidebar-champ sidebar-groupe">
          <legend className="sidebar-label">Scénarios climatiques</legend>
          {RCP_OPTIONS.map((option) => (
            <label key={option.value} className="sidebar-radio">
              <input
                type="radio"
                name="scenario-clim-classement"
                value={option.value}
                checked={rcp === option.value}
                onChange={(e) => setRcp(e.target.value)}
              />
              <span>{option.label}</span>
            </label>
          ))}
        </fieldset>
      </SidebarParametres>

      <main className="oad-cards">
        <section className="oad-card">
          <h2 className="tdb-section-titre">Classement des solutions d'adaptation</h2>
          {error && <p className="tdb-erreur">{error}</p>}
          {loading ? (
            <p className="tdb-chargement">Chargement…</p>
          ) : (
            !error && (
              <LimiteErreur cle={`${annee}-${rcp}`}>
                <ClassementAdaptationsChart data={data?.solutions ?? []} />
              </LimiteErreur>
            )
          )}
        </section>
      </main>
    </div>
  );
}
